import { request } from 'Lib/axios'
import { useQuery } from '@tanstack/react-query'
import { ExtractFnReturnType, QueryConfig } from 'Lib/react-query'
import { useUserStore } from 'Stores/userStoreModuleFed'

type GetTagValidationResponse = {
  data: {
    protected: boolean
    domain: string
  }
}

type QueryFnType = typeof getTagValidation

export const useGetTagValidation = ({
  domainId,
  config,
}: {
  domainId: number
  config?: QueryConfig<QueryFnType>
}) => {
  const { accountId, subscriptionId } = useUserStore()

  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['validateDomain', domainId],
    queryFn: () => getTagValidation(domainId, accountId),
    enabled: !!accountId && !!subscriptionId,
    staleTime: 0,
    ...config,
  })
}

const getTagValidation = async (
  domainId: number,
  accountId: number
): Promise<GetTagValidationResponse | Error> => {
  return await request<GetTagValidationResponse>({
    url: `tag-validation/${accountId}/${domainId}`,
    method: 'GET',
  })
}
